export const items = [
    {
        id: 'e1',
        title: 'Toilet Paper',
        amount: 94.12,
        date: new Date(2020, 7, 14),
    },
    { id: 'e2', title: 'New TV', amount: 799.49, date: new Date(2021, 2, 12) },
    {
        id: 'e3',
        title: 'Car Insurance',
        amount: 294.67,
        date: new Date(2021, 2, 28),
    },
    {
        id: 'e5',
        title: 'PS5',
        amount: 35000,
        date: new Date(2023, 7, 12),
    }, {
        id: 'e6',
        title: 'Samsung Galaxy S24 Ultra',
        amount: 120000,
        date: new Date(2023, 2, 5),
    },
];
